export default __webpack_public_path__ + "static/media/json.9f0210f8.png";